export enum UserProperties {
	USER_ID = 'api_user_id',
}